import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-[var(--color-surface-elevated)] text-[var(--color-text-secondary)]',
        success: 'border-transparent bg-[var(--color-success)]/15 text-[var(--color-success)]',
        warning: 'border-transparent bg-[var(--color-warning)]/15 text-[var(--color-warning)]',
        danger: 'border-transparent bg-[var(--color-danger)]/15 text-[var(--color-danger)]',
        accent: 'border-transparent bg-[var(--color-accent)]/20 text-[var(--color-accent-soft)]',
        outline: 'text-[var(--color-text-secondary)]',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { badgeVariants }
